import React, { useState, useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { base_url } from "../../Global";

const FeedChart = () => {
  const [feeds, setFeeds] = useState([]);
  const chartRef = useRef(null);      // ✅ ref instead of getElementById
  const chartInstance = useRef(null); // ✅ ref instead of state (avoids stale closure)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) throw new Error("Access token not found");
        const response = await fetch(base_url + "/entity/feed", {
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken,
          },
        });
        const feedData = await response.json();
        setFeeds(feedData?.allMedia || []);
      } catch (error) {
        console.error("Error fetching feed data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!feeds.length || !chartRef.current) return;

    // ✅ Destroy previous chart before creating new one
    if (chartInstance.current) {
      chartInstance.current.destroy();
      chartInstance.current = null;
    }

    const monthlyCounts = countByMonth(feeds);
    const labels = [5,4,3,2,1,0].map(getMonthName);

    chartInstance.current = new Chart(chartRef.current, {
      type: "bar",
      data: {
        labels,
        datasets: [{
          label: "Feeds",
          data: monthlyCounts,
          backgroundColor: "rgba(54, 162, 235, 0.5)",
          borderColor: "rgba(54, 162, 235, 1)",
          borderWidth: 1,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          y: { beginAtZero: true, title: { display: true, text: "Number of Feeds" } },
          x: { title: { display: true, text: "Month" } },
        },
      },
    });

    // ✅ Cleanup on unmount
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [feeds]);

  const countByMonth = (items) => {
    const currentDate = new Date();
    const monthlyCounts = Array(6).fill(0);
    items?.forEach((item) => {
      const createdAtDate = new Date(item.lastUpdatedAt);
      const diffMonths =
        (currentDate.getFullYear() - createdAtDate.getFullYear()) * 12 +
        (currentDate.getMonth() - createdAtDate.getMonth());
      if (diffMonths < 6) monthlyCounts[5 - diffMonths]++;
    });
    return monthlyCounts;
  };

  const getMonthName = (monthIndex) => {
    const currentDate = new Date();
    const targetDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - monthIndex, 1);
    return ["January","February","March","April","May","June","July","August","September","October","November","December"][targetDate.getMonth()];
  };

  if (!feeds.length) return null;

  return (
    <div style={{
      width: "100%",
      backgroundColor: "#1f2937",
      borderRadius: "18px",
      padding: "20px 16px",
      boxSizing: "border-box",
      boxShadow: "0 0 14px rgba(0,0,0,0.15)",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    }}>
      {/* Header */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "8px",
      }}>
        <h2 style={{ margin: 0, color: "white", fontSize: "clamp(1rem, 3vw, 1.4rem)", fontWeight: 600 }}>
          Feeds
        </h2>
        <span style={{
          color: "white",
          fontSize: "clamp(1rem, 3vw, 1.4rem)",
          fontWeight: 700,
        }}>
          {feeds.length}
        </span>
      </div>

      {/* ✅ Canvas wrapped in responsive div */}
      <div style={{ width: "100%", overflowX: "hidden" }}>
        <canvas ref={chartRef} />
      </div>
    </div>
  );
};

export default FeedChart;